var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    className: "icon-svg icon-download",
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12C1.55228 12 2 12.4477 2 13V15.4C2 15.7581 2.27508 16 2.55556 16H13.4444C13.725 16 14 15.7581 14 15.4V13C14 12.4477 14.4477 12 15 12C15.5523 12 16 12.4477 16 13V15.4C16 16.8093 14.8822 18 13.4444 18H2.55556C1.11782 18 0 16.8093 0 15.4V13C0 12.4477 0.447715 12 1 12Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19184 8.28301C4.58782 7.89802 5.22093 7.90694 5.60591 8.30292L8.00002 10.7654L10.3941 8.30293C10.7791 7.90694 11.4122 7.89802 11.8082 8.283C12.2042 8.66798 12.2131 9.30109 11.8281 9.69707L8.71703 12.8971C8.52875 13.0907 8.27013 13.2 8.00003 13.2C7.72993 13.2 7.47131 13.0907 7.28303 12.8971L4.17192 9.69708C3.78694 9.30109 3.79585 8.66799 4.19184 8.28301Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00024 0C8.55253 0 9.00024 0.447715 9.00024 1V12.2C9.00024 12.7523 8.55253 13.2 8.00024 13.2C7.44796 13.2 7.00024 12.7523 7.00024 12.2V1C7.00024 0.447715 7.44796 0 8.00024 0Z",
    fill: "#FFFFFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.123d5ca7a1766d66ebc682dbe9228b90.svg";
export { ForwardRef as ReactComponent };